<div
  class="k-dropdown dialog-dropdown sort-filter-dropdown"
  [ngClass]="{ expanded: isOpen }"
  (baseClickOutside)="isOpen = false"
>
  <button
    type="button"
    class="btn btn-md text-nowrap px-0 border-0"
    (click)="toggle()"
  >
    <i
      class="fa-solid fa-fw ms-4"
      [ngClass]="{
        'fa-arrow-up-wide-short': activeOrderDirection === baseOrderDirectionType.asc,
        'fa-arrow-down-wide-short': activeOrderDirection === baseOrderDirectionType.desc,
        'fa-bars-sort': !activeOrderDirection
      }"
    ></i>
    <span baseTruncate>{{ placeholder | translate }}</span>
    <i
      class="fa-solid fa-fw"
      [ngClass]="isOpen ? 'fa-angle-up' : 'fa-angle-down'"
    ></i>
  </button>
  <div
    class="menu"
    [ngClass]="{ open: isOpen, upward: shouldOpenUpward && isOpen }"
    (click)="isOpen = false"
    #dropdownElement
  >
    <ul class="list-unstyled">
      <ng-container *ngFor="let item of items; let i = index">
        <li
          class="pointer"
          (click)="onClickListItem(item)"
        >
          <span>{{ bindOptionLabel ? (item[bindOptionLabel] | translate) : (item | translate) }}</span>
        </li>
        <hr *ngIf="i !== items.length - 1" />
      </ng-container>
    </ul>
  </div>
</div>
